import * as actionTypes from '../../actions/actionTypes';
import { moduleTypes } from '../../util/constants';
import { getAxiosInstance } from '../../util/service';

/**
 * Service Call Actions (v2)
 * 
 * Changes:
 *  - Removed store.getState() anti-pattern → uses getState via thunk second arg
 *  - Removed unused getCompanyId import
 *  - Cleaner error handling
 */

const cloneInvoice = (obj) => JSON.parse(JSON.stringify(obj || {}));

export const uploadAttachments = (name, formObject, invoiceId) => {
    const url = `invoice/${invoiceId}/attachments?attachmentType=${name}`;
    return async (dispatch, getState) => {
        try {
            const response = await getAxiosInstance(moduleTypes.DISPATCH).post(url, formObject);
            if (response.status === 200) {
                const _invoiceObj = cloneInvoice(getState().invoiceInfo._invoiceObj);
                const item = response.data.response[0];
                if (name === 'towsheet') {
                    _invoiceObj.vendorAttachments.push(item);
                } else {
                    _invoiceObj.invoiceAttachments.push(item);
                }
                dispatch({ type: actionTypes.GET_INVOICE_INFO, _invoiceObj });
                return response.data;
            }
            return response.data;
        } catch (ex) {
            return { statusCode: null, statusMsg: ex.message };
        }
    };
};

export const deleteAttachments = (invoiceId, name, id) => {
    const url = `invoice/${invoiceId}/attachment/${id}?attachmentType=${name}`;
    return async (dispatch, getState) => {
        try {
            const response = await getAxiosInstance(moduleTypes.DISPATCH).delete(url);
            if (response.status === 200) {
                const _invoiceObj = cloneInvoice(getState().invoiceInfo._invoiceObj);
                const listKey = name === 'towsheet' ? 'vendorAttachments' : 'invoiceAttachments';
                const idx = _invoiceObj[listKey].findIndex((item) => item.attachmentId === id);
                if (idx !== -1) _invoiceObj[listKey].splice(idx, 1);
                dispatch({ type: actionTypes.GET_INVOICE_INFO, _invoiceObj });
                return { statusCode: response.status, statusMsg: response.data.statusMsg };
            }
            return { statusCode: null, statusMsg: response.data.statusMsg };
        } catch (error) {
            return { statusCode: null, statusMsg: error.message };
        }
    };
};

export const deleteNotes = (invoiceId, id) => {
    const url = `invoice/${invoiceId}/notes/${id}`;
    return async (dispatch, getState) => {
        try {
            const response = await getAxiosInstance(moduleTypes.DISPATCH).delete(url);
            if (response.status === 200) {
                const _invoiceObj = cloneInvoice(getState().invoiceInfo._invoiceObj);
                const idx = _invoiceObj.invoiceNotes.findIndex((item) => item.invoiceNotesId === id);
                if (idx !== -1) _invoiceObj.invoiceNotes.splice(idx, 1);
                dispatch({ type: actionTypes.GET_INVOICE_INFO, _invoiceObj });
                return { statusCode: response.status, statusMsg: response.data.statusMsg };
            }
            return { statusCode: null, statusMsg: response.data.statusMsg };
        } catch (error) {
            return { statusCode: null, statusMsg: error.message };
        }
    };
};

export const addUserNotes = (invoiceId, noteId, noteTxt) => {
    const url = `invoice/${invoiceId}/notes/${noteId}`;
    return async (dispatch, getState) => {
        try {
            const response = await getAxiosInstance(moduleTypes.DISPATCH).put(url, noteTxt, {
                headers: { 'Content-Type': 'application/json' },
            });
            if (response.status === 200) {
                const _invoiceObj = cloneInvoice(getState().invoiceInfo._invoiceObj);
                if (noteId === 0) {
                    _invoiceObj.invoiceNotes.push(response.data.response);
                } else {
                    const idx = _invoiceObj.invoiceNotes.findIndex((x) => x.invoiceNotesId === noteId);
                    if (idx !== -1) _invoiceObj.invoiceNotes[idx].notesText = response.data.response.notesText;
                }
                dispatch({ type: actionTypes.GET_INVOICE_INFO, _invoiceObj });
                return { statusCode: response.status, statusMsg: response.data.statusMsg };
            }
            return { statusCode: null, statusMsg: response.data.statusMsg };
        } catch (ex) {
            return { statusCode: null, statusMsg: ex.message };
        }
    };
};
